import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/login-hero.jpg'


const _hoisted_1 = { class: "grid grid-nogutter surface-section text-800 m-0 p-0" }
const _hoisted_2 = { class: "col-12 md:col-5 p-6 text-center md:text-left flex align-items-center justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-7xl text-primary font-bold" }, "PowerX", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "block text-3xl font-bold mb-3" }, "Solar", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-900 font-medium mb-2",
  for: "username1"
}, "Username", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-900 font-medium mb-2",
  for: "password1"
}, "Password", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 mb-0 text-600 text-sm text-center" }, [
  /*#__PURE__*/_createTextVNode(" Powered by "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-primary no-underline font-medium",
    href: "https://craftdar.com",
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Craftdar")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 md:col-7 overflow-hidden p-0 m-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Login",
    class: "md:ml-auto block md:h-full",
    src: _imports_0,
    style: {"clip-path":"polygon(8% 0%, 100% 0%, 100% 100%, 0 100%)","max-height":"97vh"}
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.doLogin()), ["prevent"])),
          ref: "login-form"
        }, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createVNode(_component_PInputText, {
              autocomplete: "username",
              class: "w-full mb-3",
              id: "username1",
              type: "text",
              modelValue: _ctx.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_6,
            _createVNode(_component_PInputText, {
              autocomplete: "current-password",
              class: "w-full mb-3",
              id: "password1",
              type: "password",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_PButton, {
              loading: _ctx.loading,
              class: "p-button-raised w-full mt-3",
              label: "Sign In",
              type: "submit"
            }, null, 8, ["loading"]),
            _hoisted_7
          ])
        ], 544)
      ])
    ]),
    _hoisted_8
  ]))
}